import PropTypes from 'prop-types';
import UIIconButton from 'UIComponents/button/UIIconButton';
import { CALYPSO } from 'HubStyleTokens/colors';
import UIIcon from 'UIComponents/icon/UIIcon';
import { jsx as _jsx } from "react/jsx-runtime";
const CallRecordingDeleteButton = ({
  onDeleteRecording,
  disableDelete = false
}) => {
  return /*#__PURE__*/_jsx(UIIconButton, {
    className: "m-left-2",
    color: CALYPSO,
    "data-selenium-test": "call-recording-delete-button",
    "data-test-id": "call-recording-delete-button",
    onClick: onDeleteRecording,
    disabled: disableDelete,
    size: "md",
    use: "link",
    children: /*#__PURE__*/_jsx(UIIcon, {
      name: "delete"
    })
  });
};
CallRecordingDeleteButton.propTypes = {
  onDeleteRecording: PropTypes.func.isRequired
};
export default CallRecordingDeleteButton;